<div class="step-content">
  <h2 class="attachments-header-text">Move to job shortlist</h2>
  <common-mojo-tag
    class="secondary-tag"
    [(tags)]="jobs"
    (tagsChange)="jobSelectionChange($event)"
    [allowCreate]="true"
    [tagsSelected]="tagsSelected$ | async"
    [hasOptionSecondRow]="true"
    [maxTagsSize]="5"
    [sizeToShowInputLengthWarning]="3"
    inputLengthWarning="You can select maximum 5 jobs"
    data-cy="search-job-assign-candidate"
    [autocompleteService]="jobService"
    [optionLabelTemplate]="secondaryLabel"
    inputLabel="Search for job title or job ID"
    color="accent"
  ></common-mojo-tag>

  <ng-container *mojoHasFeatureExtension="greenhouseFE; else shortlistNote">
  </ng-container>

  <ng-template #shortlistNote>
    <ng-container *ngIf="jobs.length> 0">
      <h2>Shortlist note</h2>
      <form [formGroup]="form">
        <mojo-editor
          formControlName="noteComment"
          placeholder="Share some highlights you see in candidate"
          toolbar=""
          [disabled]="saveClicked"
          [maxLength]="3000"
          data-cy="assign-candidate-note-form"
        >
        </mojo-editor>
      </form>
    </ng-container>
  </ng-template>

  <div class="button-row">
    <button
      *ngIf="!saveClicked"
      mat-button
      color="primary"
      class="md assign-button color-skype mr-1"
      [disabled]="jobs.length !== 0"
      (click)="closeDialog()"
    >Skip
    </button>
    <button
      *ngIf="!saveClicked"
      data-cy="assign-to-job-save-button"
      mat-flat-button
      color="primary"
      class="md assign-button"
      [disabled]="!allowIgnoreAssigning && jobs.length === 0 &&
      (associationConfigurationsLoaded$ | async)"
      (click)="onSaveClicked()"
    >SAVE
    </button>
    <mojo-loader *ngIf="saveClicked || (associationConfigurationsLoaded$ |
      async) === false"></mojo-loader>
  </div>
</div>

<ng-template
  #secondaryLabel
  let-tag
  let-searchPhrase="searchPhrase"
>
  <div class="secondary-label">
    <div class="id label-element">Job ID:
      <span [attr.data-cy]="'mojo-autocomplete-option-' + tag.id">
        <common-mojo-mark-search-phrase-box
          [markedSearchPhrase]="searchPhrase"
          [text]="tag.id.toString()"
        >
        </common-mojo-mark-search-phrase-box>
      </span>
    </div>
    <div
      *ngIf="!!tag.clientReqId"
      class="external-id label-element"
    >External ID:
      <span [attr.data-cy]="'mojo-autocomplete-option-' + tag.clientReqId">
        <common-mojo-mark-search-phrase-box
          [markedSearchPhrase]="searchPhrase"
          [text]="tag.clientReqId"
        >
        </common-mojo-mark-search-phrase-box>
      </span>
    </div>
    <div
      class="status label-element dot-active"
      [ngClass]="{'dot-inactive': tag.status !== jobStatusEnum.Progress}"
      [attr.data-cy]="'mojo-autocomplete-option-' + tag.status"
    >
      <common-mojo-mark-search-phrase-box
        [markedSearchPhrase]="searchPhrase"
        [text]="tag.status"
      >
      </common-mojo-mark-search-phrase-box>
    </div>
  </div>
</ng-template>
